import { render, staticRenderFns } from "./AzGroupsAssignTemplatesDialog.vue?vue&type=template&id=f8fe1250"
import script from "./AzGroupsAssignTemplatesDialog.vue?vue&type=script&lang=js"
export * from "./AzGroupsAssignTemplatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports